import React from "react";
import MarkdownDocPage from "@/components/MarkdownDocPage";
import { Users, Bot, Layers, DollarSign } from "lucide-react";

const STATS = [
  { icon: Users, label: "Human roles", value: "14 mapped" },
  { icon: Bot, label: "AI & software", value: "13-tool stack" },
  { icon: Layers, label: "Model", value: "AI-augmented" },
  { icon: DollarSign, label: "Pay & sourcing", value: "US 2026" },
];

export default function StaffingPlan() {
  return (
    <MarkdownDocPage
      title="Staffing & AI Stack Build-Out"
      subtitle="Everything to pull this off — who to hire, how, how much to pay, where to source, and which AI/software to use. Lean, AI-augmented model."
      mdUrl="/docs/GoMCO-Staffing-and-AI-Stack.md"
      pdfKey="staffing-ai-stack"
      pdfName="GoMCO-Staffing-and-AI-Stack.pdf"
      stats={STATS}
      testid="staffing-content"
    />
  );
}
